import Cookies from "js-cookie";

const safeEncode = (str) => btoa(encodeURIComponent(str));
const safeDecode = (str) => decodeURIComponent(atob(str || ""));

const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      // Hỗ trợ cả payload mới và cũ
      const token =
        action.payload?.token ?? action.payload?.token_client ?? null;

      const refreshToken =
        action.payload?.refreshToken ?? action.payload?.refresh_token ?? null;

      const user = action.payload?.user ?? action.payload?.user_client ?? null;

      // Lưu cookie
      if (token) Cookies.set("token_client", token, { expires: 7 });
      else Cookies.remove("token_client");

      if (user) {
        const encodedUser = safeEncode(JSON.stringify(user));
        Cookies.set("user_client", encodedUser, { expires: 7 });
      } else {
        Cookies.remove("user_client");
      }

      // Nếu bạn muốn lưu luôn refreshToken:
      if (refreshToken) {
        Cookies.set("refresh_token_client", refreshToken, { expires: 14 });
      } else {
        Cookies.remove("refresh_token_client");
      }

      return {
        token_client: token,
        user_client: user,
      };
    }

    case "UPDATE_USER_INFO": {
      const newUser =
        action.payload?.user ?? action.payload?.user_client ?? null;

      const updatedUser = newUser ? { ...state.user_client, ...newUser } : null;

      if (updatedUser) {
        const encoded = safeEncode(JSON.stringify(updatedUser));
        Cookies.set("user_client", encoded, { expires: 7 });
      } else {
        Cookies.remove("user_client");
      }

      return {
        ...state,
        user_client: updatedUser,
      };
    }

    case "LOGOUT": {
      Cookies.remove("token_client");
      Cookies.remove("user_client");
      Cookies.remove("refresh_token_client");
      return { token_client: null, user_client: null };
    }

    default:
      return state;
  }
};

export default AuthReducer;
